import { Table } from "react-bootstrap";
import {
  Archive,
  Pencil,
  JournalText,
} from "react-bootstrap-icons";
import { Currency } from "../../../../lib/components/Currency";
import { FormattedDateTime } from "../../../../lib/components/FormattedDate";

export function CommissionDetailsRow({
  colSpan,
  commissionRecords,
  itemRecords,
  contractAdjustments,
  notes,
}) {
  return (
    <tr className="details-row">
      <td colSpan={colSpan}>
        {commissionRecords?.length > 0 && (
          <DetailSection
            title="Commission records"
            icon={<Archive size={12} aria-hidden="true" />}
          >
            <Table
              responsive
              className="data-table data-table--nested align-middle"
            >
              <thead>
                <tr>
                  <th>Rule</th>
                  <th className="col-money">Amount</th>
                </tr>
              </thead>
              <tbody>
                {commissionRecords.map((r, i) => (
                  <tr key={r.commissionAgentContractId ?? i}>
                    <td>{r.ruleName || "-"}</td>
                    <td className="col-money tnum col-money--emphasis">
                      <Currency amount={r.amount} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </DetailSection>
        )}
        {itemRecords.length > 0 && (
          <DetailSection
            title="Item records"
            icon={<Archive size={12} aria-hidden="true" />}
          >
            <Table
              responsive
              className="data-table data-table--nested align-middle"
            >
              <thead>
                <tr>
                  <th>Item #</th>
                  <th>Group</th>
                  <th>Category</th>
                  <th className="col-money">Price</th>
                  <th className="col-money">Net price</th>
                  <th className="col-money">Base value</th>
                  <th className="col-money">Amount</th>
                </tr>
              </thead>
              <tbody>
                {itemRecords.map((item, i) => (
                  <tr key={item.itemNumber || i}>
                    <td>{item.itemNumber || "-"}</td>
                    <td>{item.group || "-"}</td>
                    <td>{item.category || "-"}</td>
                    <td className="col-money tnum">
                      <Currency amount={item.price} />
                    </td>
                    <td className="col-money tnum">
                      <Currency amount={item.netPrice} />
                    </td>
                    <td className="col-money tnum">
                      <Currency amount={item.baseValue} />
                    </td>
                    <td className="col-money tnum col-money--emphasis">
                      <Currency amount={item.amount} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </DetailSection>
        )}

        {contractAdjustments.length > 0 && (
          <DetailSection
            title="Contract adjustments"
            icon={<Pencil size={12} aria-hidden="true" />}
          >
            <Table
              responsive
              className="data-table data-table--nested align-middle"
            >
              <thead>
                <tr>
                  <th>User</th>
                  <th>Date</th>
                  <th>Reason</th>
                  <th className="col-money">Amount</th>
                </tr>
              </thead>
              <tbody>
                {contractAdjustments.map((a, i) => (
                  <tr key={a.commissionAgentContractAdjustmentId || i}>
                    <td>{a.createdBy || "-"}</td>
                    <td>
                      {a.created ? <FormattedDateTime date={a.created} /> : "-"}
                    </td>
                    <td>{a.reason || "-"}</td>
                    <td className="col-money tnum col-money--emphasis">
                      <Currency amount={a.adjustmentAmount} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </DetailSection>
        )}

        {notes && (
          <DetailSection
            title="Notes"
            icon={<JournalText size={12} aria-hidden="true" />}
          >
            <p>{notes}</p>
          </DetailSection>
        )}
      </td>
    </tr>
  );
}

function DetailSection({ title, icon, children }) {
  return (
    <div className="details-section">
      <div className="details-section-title">
        {icon && <span className="details-section-icon">{icon}</span>}
        {title}
      </div>
      {children}
    </div>
  );
}
